import { Button, Grid, makeStyles } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { clearManagementSlice } from './redux/management.slice';
import RepManagementContainer from './RepManagementContainer';
import TeamManagementContainer from './TeamManagementContainer';
import CompanyManagementContainer from './CompanyManagementContainer';
import QuotaManagementCard from './QuotaManagementCard';

const useStyles = makeStyles((theme) => ({
    cardWrapper: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        columnGap: "1rem",
        rowGap: "1.5rem",
        maxWidth: "1200px",
        margin: "2rem auto 1rem",
        padding: "0 1rem",

        [theme.breakpoints.down("md")]: {
          gridTemplateColumns: "repeat(2, 1fr)",
        },
        [theme.breakpoints.down("sm")]: {
          gridTemplateColumns: "1fr",
        },
    },
}));

const QuotaManagementRoot = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const baseURL = "https://skygeniwebapp.blob.core.windows.net/thumbnails/";

    useEffect(()=>{
        return () => {
            dispatch(clearManagementSlice())
        }
    },[])
    const [view, setView] = useState("root") // initial view is "root"

    const renderRootView = () => (
        <div className={classes.cardWrapper}>
            <QuotaManagementCard
                header="Rep Quota Management"
                text="Add / Delete / Update Quota for Reps"
                image={`${baseURL}Stage Progression Analysis.png`}
                onClick={() => setView("rep")}
            />
            <QuotaManagementCard
                header="Team Quota Management"
                text="Add / Delete / Update Quota for Teams"
                image={`${baseURL}Stage Progression Analysis.png`}
                onClick={() => setView("team")}
            />
            <QuotaManagementCard
                header="Company Quota Management"
                text="Add / Delete / Update Quota for Companies"
                image={`${baseURL}Stage Progression Analysis.png`}
                onClick={() => setView("company")}
            />
        </div>
    );

    const renderDetailView = () => (
        <Grid container>
            <Grid item container xs={12} justifyContent='flex-start' style={{paddingBottom:'1rem'}}>
                <Button
                  onClick={() => setView("root")}
                  style={{ minWidth: 0, padding: 6 }}
                >
                  <ArrowBackIcon style={{ fontSize: 24, color: '#4472c4' }} />
                </Button>
            </Grid>
            {view === "rep" && <Grid container xs={12} item><RepManagementContainer /></Grid>}
            {view === "team" && <Grid container xs={12} item><TeamManagementContainer /></Grid>}
            {view === "company" && <Grid container xs={12} item><CompanyManagementContainer /></Grid>}
        </Grid>
    );

    return (
        <Grid container>
            {view === "root" ? renderRootView() : renderDetailView()}
        </Grid>
    )
}

export default QuotaManagementRoot